import { CHARGE_CDN } from "@/utils/constants";
import { callbackData, closeWindow } from "@/utils/common";
import "./index.less";
import shareImg from "../../assets/share.png";
import { processOssImage } from "@xp-design/mobile/lib/utils/oss-process-image";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { useMount } from "ahooks";
import { getReportVipData } from "../../utils";
import { trackGdp } from "@/utils/gio-report";
import { useUserContext } from "../../routes/home/userContext";
import { getBrowserEnv } from "@/utils/tools";
import { useRef } from "react";
import { removeUrlParameters } from "@/utils/url";

const { isXPApp } = getBrowserEnv();

const AppNavBar = ({
  bgWhite = false,
  onBack,
}: {
  bgWhite?: boolean;
  onBack?: () => void;
}) => {
  const { levelInfo } = useUserContext();
  const { setSharePath, onNavShareClick, setNavHeight, configPageQuery } =
    useConfigPage();
  const navBarRef = useRef<HTMLDivElement>(null);

  // 获取div高度并写入context

  const setNativeResult = () => {
    callbackData({
      vipReturn: true,
    });
  };

  const goBack = () => {
    if (onBack) {
      onBack();
    }
    setNativeResult();
    closeWindow();
  };

  useMount(() => {
    setNativeResult();
    if (setSharePath) {
      setSharePath(`${removeUrlParameters(window.location.href, {}, true)}`);
    }

    // 获取div高度并写入context
    if (navBarRef.current && setNavHeight) {
      const height = navBarRef.current.offsetHeight;
      setNavHeight(height);
    }
  });

  const share = () => {
    trackGdp("P11222", "B008", {
      ...getReportVipData(levelInfo),
    });
    if (onNavShareClick) onNavShareClick();
  };

  if (!isXPApp) {
    return null;
  }

  return (
    <div ref={navBarRef} className={`vip-nav-bar ${bgWhite ? "bg-white" : ""}`}>
      {bgWhite ? (
        <img
          src={processOssImage(`${CHARGE_CDN}/common/back_black.png`)}
          alt=""
          className="icon"
          onClick={goBack}
        />
      ) : (
        <img
          src={processOssImage(`${CHARGE_CDN}/common/back_white.png`)}
          alt=""
          className="icon"
          onClick={goBack}
        />
      )}
      <span className={`title ${bgWhite ? "title-black" : ""}`}>
        {configPageQuery?.data?.pageTitle || "充电会员"}
      </span>
      {bgWhite ? (
        <img
          src={processOssImage(shareImg)}
          alt=""
          className="icon"
          onClick={share}
        />
      ) : (
        <img
          src={processOssImage(`${CHARGE_CDN}/common/share_white.png`)}
          alt=""
          className="icon"
          onClick={share}
        />
      )}
    </div>
  );
};

export default AppNavBar;
